import React from "react";
import { Routes, Route } from "react-router-dom";
import FaqList from "./faq-list";
import FaqNew from "./add-faq";
import EditFaq from "./edit-faq";

//
const Faq = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<FaqList />} />
         <Route path="/" element={<FaqList />} />
         <Route path="/edit/:id" element={<EditFaq />} />
         <Route path="/new" element={<FaqNew />} />
      </Routes>
    </React.Fragment>
  );
};

export default Faq;
